"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllowedDomain = void 0;
const WHITELISTED_DOMAINS = ['.hlag.cloud', '.hapag-lloyd.com', '.hapag-lloyd.cn', 'localhost:8080'];
const isAllowedDomain = url => {
  try {
    const {
      origin
    } = new URL(url);
    return WHITELISTED_DOMAINS.filter(whitelistedDomain => origin.endsWith(whitelistedDomain)).length > 0;
  } catch (_a) {
    return false;
  }
};
exports.isAllowedDomain = isAllowedDomain;
//# sourceMappingURL=validator.js.map